// extracted by mini-css-extract-plugin
module.exports = {"hidden":"ImageLoader_hidden__HlsIc","placeholder":"ImageLoader_placeholder__3s-p0","imageWrapper":"ImageLoader_imageWrapper__HZo9W"};